export default __webpack_public_path__ + "static/media/SDG6.4c8255cb.png";